import { Format } from "../../../../helpers/formatters";
import { ChangeEvent } from "react";

export const brandTypes = [ 'MASTERCARD', 'VISA', 'ELO', 'AMERICAN_EXPRESS' ];

export function formatCPFInput(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = Format.maskCPFCNPJ(e.target.value);
}

export function formatNCardInput(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = Format.convertNumberCard(e.target.value);
}

export function formatValidityInput(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = Format.monthYear(e.target.value);
}

export function formatCVVInput(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = Format.onlyNumber(e.target.value);
}

export function getValidityInput(value : string) {
    return value  = value.replace('/', '');
}

export function getNCardInput(value : string) {
    return value.replace(/\s/g, '');
}